module.exports = __webpack_public_path__ + "img/bg1.d96f5607.png";